import svg4everybody from "svg4everybody"

const legacy = () => {
	svg4everybody()
}

export default legacy
